import React, { Component } from "react";
import NavbarBG from "../assets/NavBarBackground.svg";
import Logo from "../assets/logo-with-text.svg";
import { NavLink, Link } from "react-router-dom";
import Hamburger from "react-hamburgers";

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, isOpen: false, startAnimate: false };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  hamburgerClick = () => {
    let isOpen = this.state.isOpen;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    return (
      <div className="navbar">
        <img
          src={NavbarBG}
          alt=""
          className={!this.state.isOpen ? "navbar-bg is-closed" : "navbar-bg"}
        />
        {this.state.width > 1130 ? (
          <div className="">
            <div className="wrapper navbar-container">
              <Link to="/" className="navbar-logo-container">
                <img src={Logo} alt="" className="navbar-logo" />
              </Link>
              <div className="navbar-links">
                <NavLink
                  exact={true}
                  activeClassName="current-page"
                  className="link"
                  to="/"
                >
                  <p>home</p>
                </NavLink>
                <NavLink
                  exact={true}
                  activeClassName="current-page"
                  className="link"
                  to="/about"
                >
                  <p>about</p>
                </NavLink>
                <NavLink
                  exact={true}
                  activeClassName="current-page"
                  className="link"
                  to="/portfolio"
                >
                  <p>portfolio</p>
                </NavLink>
                <NavLink
                  exact={true}
                  activeClassName="current-page"
                  className="link"
                  to="/contact"
                >
                  <p>contact</p>
                </NavLink>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="wrapper navbar-container">
              <Link to="/" className="navbar-logo-container">
                <img src={Logo} alt="" className="navbar-logo" />
              </Link>
              <div className="hamburger">
                <Hamburger
                  type="spin"
                  onClick={this.hamburgerClick}
                  // className="hamburger"
                  active={this.state.isOpen}
                />
              </div>
            </div>
            {this.state.isOpen ? (
              <div className={"navbar-links-mobile"}>
                {/* <ScrollAnimation animateIn="one"> */}
                <NavLink
                  onClick={this.hamburgerClick}
                  exact={true}
                  activeClassName="current-page"
                  className="link one extra-space"
                  to="/"
                >
                  <p>home</p>
                </NavLink>
                {/* </ScrollAnimation> */}

                {/* <ScrollAnimation animateIn="two"> */}
                <NavLink
                  onClick={this.hamburgerClick}
                  exact={true}
                  activeClassName="current-page"
                  className="link two"
                  to="/about"
                >
                  <p>about</p>
                </NavLink>
                {/* </ScrollAnimation> */}
                {/* <ScrollAnimation animateIn="three"> */}
                <NavLink
                  onClick={this.hamburgerClick}
                  exact={true}
                  activeClassName="current-page"
                  className="link three"
                  to="/portfolio"
                >
                  <p>portfolio</p>
                </NavLink>
                {/* </ScrollAnimation> */}

                {/* <ScrollAnimation animateIn="four"> */}
                <NavLink
                  onClick={this.hamburgerClick}
                  exact={true}
                  activeClassName="current-page"
                  className="link four"
                  to="/contact"
                >
                  <p>contact</p>
                </NavLink>
                {/* </ScrollAnimation> */}
              </div>
            ) : null}
          </>
        )}
      </div>
    );
  }
}
